import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Sparkles, LogOut, CreditCard, Crown } from "lucide-react";

export default function Navbar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <header className="border-b border-white/5 bg-bg/80 backdrop-blur-md sticky top-0 z-40" data-testid="navbar">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
                    <div className="w-8 h-8 rounded-md bg-accent/10 border border-accent/30 flex items-center justify-center">
                        <Sparkles className="w-4 h-4 text-accent" strokeWidth={2} />
                    </div>
                    <span className="font-semibold text-zinc-100 tracking-tight">listcraft<span className="text-accent">.</span></span>
                </Link>

                <nav className="hidden md:flex items-center gap-7 text-sm">
                    <Link to="/showcase" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="nav-showcase">Showcase</Link>
                    <Link to="/pricing" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="nav-pricing">Pricing</Link>
                    {user && (
                        <>
                            <Link to="/dashboard" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="nav-dashboard">Dashboard</Link>
                            <Link to="/generate" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="nav-generate">Generate</Link>
                            <Link to="/billing" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="nav-billing">Billing</Link>
                        </>
                    )}
                </nav>

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-md border border-white/10 bg-surface text-sm" data-testid="nav-credits">
                                <CreditCard className="w-3.5 h-3.5 text-zinc-500" />
                                <span className="font-mono text-zinc-200">{user.credits}</span>
                                {user.is_premium && (
                                    <span className="ml-1 inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-accent">
                                        <Crown className="w-3 h-3" /> pro
                                    </span>
                                )}
                            </div>
                            <button onClick={() => { logout(); navigate("/"); }} className="btn-ghost !px-3 !py-1.5 text-xs" data-testid="nav-logout">
                                <LogOut className="w-3.5 h-3.5" />
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="text-zinc-400 hover:text-zinc-100 text-sm transition-colors" data-testid="nav-login">Sign in</Link>
                            <Link to="/register" className="btn-primary !px-4 !py-2 text-sm" data-testid="nav-register">Get started</Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
